import { useContext, useCallback } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { TradingContext } from '../contexts/TradingContext';
import { AppStateContext } from '../contexts/AppStateContext';
import { StreamsContext } from '../contexts/StreamsContext';
import { BannerContext } from '../contexts/BannerContext';

const useCopyAppState = () => {
  const { user } = useContext(AuthContext);
  const trading = useContext(TradingContext);
  const app = useContext(AppStateContext);
  const streams = useContext(StreamsContext);
  const { showMessage } = useContext(BannerContext);

  const copyState = useCallback(async () => {
    try {
      const userSubset = user ? {
        id: user.id,
        email: user.email,
        superuser: user.superuser,
        beta_user: user.beta_user,
        appSettings: user.appSettings,
        accountDefaults: user.accountDefaults,
      } : null;

      const tradingSubset = {
        selectedAccount: trading?.selectedAccount,
        accounts: trading?.accounts,
        balances: trading?.balances,
        orders: trading?.orders,
        positions: trading?.positions,
        selectedTicker: trading?.selectedTicker,
        isFutures: trading?.isFutures,
        isPaperTrading: trading?.isPaperTrading,
      };

      const snapshot = {
        user: userSubset,
        trading: tradingSubset,
        app: {
          risk: app?.risk,
          orderType: app?.orderType,
          timeInForce: app?.timeInForce,
          bracketType: app?.bracketType,
          showLiquidity: app?.showLiquidity,
          showStdDevLines: app?.showStdDevLines,
          showOrders: app?.showOrders,
          sessionTemplate: app?.sessionTemplate,
          watchlistTickers: app?.watchlistTickers,
          selectedWatchlistId: app?.selectedWatchlistId,
        },
        streams: {
          quotesBySymbol: streams?.quotesBySymbol,
          currentBalance: streams?.currentBalance,
          currentOrders: streams?.currentOrders,
        }
      };
      const text = JSON.stringify(snapshot, null, 2);
      await navigator.clipboard.writeText(text);
      showMessage && showMessage('App state copied to clipboard', 'success');
    } catch (err) {
      showMessage && showMessage('Failed to copy app state', 'danger');
    }
  }, [user, trading, app, streams, showMessage]);

  return { copyState };
};

export default useCopyAppState;


